import React from 'react';
import DocumentoNoDisponible from './DocumentoNoDisponible';

const CompendioCap6 = () => (
  <DocumentoNoDisponible titulo="Compendio Estadístico 2017 - 2021 · Capítulo 6" />
);

export default CompendioCap6;
